import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PriceList } from '../../entities/master-data/price-list-entity';
import { UserInfo } from 'src/app/tools/models/entities/user-info';

 


export class PriceListRequest extends BaseRequest{
  priceList : PriceList;
  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.priceList = new PriceList();
  }
}